import { render, staticRenderFns } from "./RecommendBanner.vue?vue&type=template&id=0ea10c68&scoped=true"
import script from "./RecommendBanner.vue?vue&type=script&lang=js"
export * from "./RecommendBanner.vue?vue&type=script&lang=js"
import style0 from "./RecommendBanner.vue?vue&type=style&index=0&id=0ea10c68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea10c68",
  null
  
)

export default component.exports